import { RouterOptions, createRouter, createWebHistory } from "vue-router";
import { UserState } from "../userState";
import { AuthControl } from "../authControl";

export const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../pages/index/index.page.vue"),
  },
  {
    path: "/from/:originTemplateId",
    name: "from",
    component: () => import("../pages/index/index.page.vue"),
  },
  {
    path: "/from/:originTemplateId/to/:destinationTemplateId",
    name: "fromto",
    component: () => import("../pages/index/index.page.vue"),
  },
  {
    path: "/to/:destinationTemplateId/from/:originTemplateId",
    name: "tofrom",
    component: () => import("../pages/index/index.page.vue"),
  },
  {
    path: "/to/:destinationTemplateId",
    name: "to",
    component: () => import("../pages/index/index.page.vue"),
  },
  {
    path: "/roadtrips/:roadtripId",
    name: "roadtrip",
    component: () => import("../pages/roadtrips/index.page.vue"),
  },
  {
    path: "/roadtrips",
    name: "roadtrips",
    component: () => import("../views/Roadtrips.vue"),
  },
  {
    path: "/stops/:stopId",
    name: "stop",
    component: () => import("../pages/stops/index.page.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/Terms.vue"),
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("../views/Pricing.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/Admin.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("../views/Settings.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/NotFound.vue"),
  },
];

export const routerOptions: RouterOptions = {
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
};

export const alwaysAvailableRoutes = [
  'home',
  'not-found',
  'privacy',
  'pricing',
  'terms',
];

export function setupRouter(userState: UserState, authControl: AuthControl) {

  const router = createRouter(routerOptions);

  router.beforeEach(async (to, from) => {
    // If we're not logged in, and we're going to a page that only makes sense authed...
    if (!userState.loading
      && !userState.isSignedIn
      && !alwaysAvailableRoutes.includes(to.name?.toString() || '')) {
      // ...then just go to the home page
      console.log('Not logged in, route requires a user, rerouting home.');
      return { name: 'home' }
    }
  })

  return router;
}

